import dayjs from "dayjs";
import "dayjs/locale/pl";
dayjs.locale("pl");

export default dayjs;
